import {GridEvent, GridEventType} from '@mintdata-wsp/common/state/ui/visualDesigner/grid/GridEvent';
import {GridMeasureRequest, OnMeasureDone} from '@mintdata-wsp/common/state/ui/visualDesigner/grid/GridMeasure';
import {IMeasureBag, IMutableGridModel} from '@mintdata-wsp/common/state/ui/visualDesigner/grid/GridModel';
import {controllers} from '@mintdata-wsp/wsp/controllers/WspControllers';
import {DataGridView} from '@mintdata-wsp/wsp/ui/components/grid/DataGridView';
import {IDisposable} from '@mintdata/mint-kit/api/resources/IDisposable';
import bind from 'bind-decorator';
import * as classnames from 'classnames/bind';
import {action} from 'mobx';
import {observer} from 'mobx-react';
import * as React from 'react';

const styles = require('./AutoGridView.less');
const cx = classnames.bind(styles);

export interface IAutoGridCommander
{
    autosizeColumns():void;
}

export interface AutoGridViewProps
{
    gridModel:IMutableGridModel;
    onCommander?:(commander:IAutoGridCommander)=>(void);
    className?:string;
    onMeasureDone?:OnMeasureDone;
}

@observer
export class AutoGridView extends React.Component<AutoGridViewProps, any> implements IAutoGridCommander
{
    private _listener:IDisposable = null;

    constructor(props:AutoGridViewProps)
    {
        super(props);
        this._init();
    }

    componentWillReceiveProps(nextProps: Readonly<AutoGridViewProps>, nextContext: any): void
    {
        this._init();
    }

    componentWillUnmount(): void
    {
        if( this._listener )
            this._listener.dispose();
    }

    @action.bound
    private _init()
    {
        if( this.props.onCommander )
            this.props.onCommander(this);

        this._requestMeasure();
        this._listenToGridEvents();
    }

    autosizeColumns(): void
    {
        this._requestMeasure();
    }

    @bind
    private _listenToGridEvents()
    {
        const {gridModel} = this.props;
        this._listener = gridModel.addListener(action((e:GridEvent)=>
        {
            // console.log(`GRID EVENT :: e: ${e}`, e);

            if( e.type === GridEventType.ColumnsAdded ||
                e.type === GridEventType.InitialRowsAdded ||
                // e.type === GridEventType.RowsAdded ||
                e.type === GridEventType.RowsAndColumnsAdded
            )
            {
                // this._currentPhase = GridRenderPhase.ReMeasure;
                this._requestMeasure();
            }
        }));
    }

    @action.bound
    private _requestMeasure()
    {
        const {gridModel} = this.props;
        const view = gridModel.getBodyWithBothHeaders();
        const numColumnsToMeasure = view.getNumColumns();
        const numRowsToMeasure = Math.min(3, view.getNumRows());
        const controller = controllers.ui.gridMeasure;

        controller.measure(new GridMeasureRequest(
                                                    gridModel,
                                                    view,
                                                    numRowsToMeasure,
                                                    numColumnsToMeasure,
                                                    7,
                                                    3,
                                                    this._onMeasureDone
                                                ));
    }

    @action.bound
    private _onMeasureDone(bag:IMeasureBag)
    {
        // console.log(`_onMeasureDone: bag:`);
        // bag.print();

        this._updateGridModelSizes(bag);

        const onMeasureDone = this.props.onMeasureDone;
        if( onMeasureDone && typeof onMeasureDone === 'function' )
            onMeasureDone(bag);
    }

    @bind
    private _updateGridModelSizes(bag:IMeasureBag):void
    {
        const {gridModel} = this.props;
        const view = gridModel.getBodyWithBothHeaders();

        for( let colIndex = 0; colIndex < bag.getNumColumns(); colIndex++ )
        {
            const widestColumn = bag.getWidestColumn(colIndex);
            // console.log(`setColumnWidth[${colIndex}] => ${widestColumn}`);
            view.setColumnWidth(colIndex, widestColumn);
        }
    }

    render()
    {
        const {gridModel, className} = this.props;
        return <DataGridView className={className} gridModel={gridModel}/>
    }
}
